// Employer-facing view of a job applicant (identity + candidate profile + docs).
// Returned by GET /api/applications/:id/applicant, gated to the need's owner.
// `has_profile` is false when the applicant never filled in a candidate profile —
// identity + documents are still present.

export interface ApplicantDocument {
    id: string;
    document_type: string;
    original_name?: string;
    mime_type?: string;
    download_url?: string; // file documents
    content?: string;      // text documents (e.g. personligt brev)
    created_at?: string;   // upload date (YYYY-MM-DD)
}

export interface ApplicantProfile {
    user_id: string;
    name: string;
    email?: string;
    phone?: string;
    picture_url?: string;

    has_profile: boolean;
    university?: string;
    education_status?: string;
    other_education?: string;
    location?: string;
    min_hours_per_week?: number;
    max_hours_per_week?: number;
    available_from_date?: string;

    documents: ApplicantDocument[];
}

export const EducationStatusLabels: Record<string, string> = {
    qualifying: 'Socionomexamen (eller motsvarande)',
    other: 'Annan utbildning',
    none: 'Ingen utbildning',
};
